export default "__VITE_ASSET__BoFwJ76x__"